import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { listComparisons, compareRun, selectComparison, clearComparisons, resetComparisons } from "../fleetOptimizationSlice";
import DeltaHeader from "./DeltaHeader";
import CaveatsBanner from "./CaveatsBanner";
import ComparisonTable from "./ComparisonTable";
import ComparisonHistoryList from "./ComparisonHistoryList";
import "./Scorecard.scss";

export default function Scorecard() {
  const { id = "" } = useParams();
  const dispatch = useAppDispatch();
  const { currentComparison, comparisons, compareAPI, comparisonsAPI } = useAppSelector((s) => s.fleetOptimization);

  // Reset any prior run's comparison state on run change, then load this run's — so
  // navigating between runs never shows another run's comparison.
  useEffect(() => {
    dispatch(resetComparisons());
    if (id) dispatch(listComparisons(id));
  }, [id, dispatch]);

  const loading = compareAPI.loading || comparisonsAPI.loading;
  const loadingLabel = compareAPI.loading
    ? "Comparing against the final schedule… (this can take a few seconds)"
    : "Loading…";

  return (
    <div className="scorecard-page">
      <div className="scorecard-head">
        <Link to={`/fleet-optimization/${id}`}>← Back to run</Link>
        <h2>Schedule vs Optimizer</h2>
        <button className="run-comparison" disabled={compareAPI.loading} onClick={() => dispatch(compareRun(id))}>
          {compareAPI.loading ? "Comparing…" : "Run comparison"}
        </button>
      </div>

      {(compareAPI.error || comparisonsAPI.error) && (
        <div className="scorecard-error">Could not run a comparison for this run. Please try again.</div>
      )}

      {loading ? (
        <div className="scorecard-loading">
          <Oval color="#131313" height={40} width={40} secondaryColor="#FBD20A" />
          <span className="scorecard-loading-text">{loadingLabel}</span>
        </div>
      ) : currentComparison ? (
        <>
          <DeltaHeader comparison={currentComparison} />
          <CaveatsBanner comparison={currentComparison} />
          <ComparisonTable comparison={currentComparison} />
        </>
      ) : (
        <p className="scorecard-empty">No comparison yet. Click "Run comparison" to score today's final schedule against this run.</p>
      )}

      <div className="scorecard-history-head">
        <h3>History</h3>
        {comparisons.length > 0 && (
          <button
            className="clear-history"
            onClick={() => {
              if (window.confirm("Clear all saved comparisons for this run?")) {
                dispatch(clearComparisons(id));
              }
            }}
          >
            Clear history
          </button>
        )}
      </div>
      <ComparisonHistoryList comparisons={comparisons} selectedId={currentComparison?.id}
        onSelect={(c) => dispatch(selectComparison(c))} />
    </div>
  );
}
